const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export const isProdEnvironment = (): boolean => {
  return API_BASE_URL.includes("api.ngft.com");
};

export const isNonProdEnvironment = (): boolean => {
  return !isProdEnvironment();
};
